import { VFC, useEffect, useState, useCallback } from "react";
import {
  Box,
  Text,
  Stack,
  Center,
  Modal,ModalOverlay,ModalContent,ModalHeader,ModalCloseButton,ModalBody,
  useDisclosure,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { LogoutButton } from "../../atoms/button/LogoutButton";
import { CompleteDialog } from "./CompleteDialog";
import { initUserObj, useLoginUser } from "../../../hooks/providers/useLoginUserProvider";
import { Auth } from "aws-amplify";

type Props = {
  errTitle: string;
  // eslint-disable-next-line
  errObj: any;
  opeErrMes: string;
  setCloseFlag?: (flag:boolean)=>void;
};

export const ErrorDialog: VFC<Props> = (props) => {
  const { errTitle, errObj, opeErrMes="", setCloseFlag=((flag:boolean)=>{return(flag)}) } = props;
  const [ errMes,setErrMes ] = useState(opeErrMes);  // 画面側のオリジナルチェックエラー
  const [ errStatus,setErrStatus ] = useState("");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [ invalidTokenFlag, setInvalidTokenFlag ] = useState(false);
  const [ invalidVersionFlag, setInvalidVersionFlag ] = useState(false);
  const { loginUser, setLoginUser } = useLoginUser();
  const navigate = useNavigate();
  
  useEffect(() => {
    // errObjがnullの場合は、opeErrMesが設定されているパタンなので、errObj判定はスキップ
    loginUser.envType === 'DEV' && console.log("ErrorDialog",errObj);
    if( !errObj ){
      return;
    }
    
    !isOpen && onOpen();
    
    // errObjがある場合は、エラー判定
    if( errObj.response ){
      setErrStatus(errObj.response.status);
      
      if( errObj.response.status === 503 ){
        // 503返却時はメンテナンス対応
        loginUser.envType === 'DEV' && console.log("メンテナンス中");
        window.location.replace("https://" + window.location.host + "/maintenance.html");
        
      } else if( errObj.response.data !== undefined && errObj.response.data !== null ){
        if(typeof(errObj.response.data) === 'object') {
          loginUser.envType === 'DEV' && console.log("opeErrMes1",errObj.response.data);
          if( errObj.response.data.message !== undefined && errObj.response.data.message !== null ){
            setErrMes(errObj.response.data.message);
          }else if( errObj.response.data.error_detail !== undefined && errObj.response.data.error_detail !== null ){
            setErrMes(errObj.response.data.error_detail);
          }else{
            setErrMes('システムエラー：不正なオブジェクト');
          }
            
        }else if(typeof(errObj.response.data) === 'string') {
          loginUser.envType === 'DEV' && console.log("opeErrMes2",errObj.response.data);
          setErrMes(errObj.response.data);
            
        }else{
          setErrMes('予期しないエラー');
        }
        
      }else{
        // BodyがないAPI GWエラー
        setErrMes("システムエラー：不正なヘッダ値");
      }
      
    }else{
      // BodyがないAPI GWエラー
      setErrMes("システムエラー：ネットワークエラー");
    }
    // eslint-disable-next-line
  }, [errObj]);
  
  useEffect(() => {
    if( errMes === 'The security token included in the request is invalid.' ||
        errMes === 'Access Denied' ||
        errMes === 'Unauthorized' ){
      setInvalidTokenFlag(true);
  
    }else if( errMes === 'api_version not match' ){
      setInvalidVersionFlag(true);
      
    }
  }, [errMes,errStatus,isOpen,onOpen]);
  
  const onClose2 = useCallback(async() => {
    onClose();
    await Auth.signOut();
    await setLoginUser(initUserObj);
    loginUser.envType === 'DEV' && console.log('ログアウト');
    navigate("/login.html");
    
  }, [onClose,setLoginUser,loginUser]);
    
  const onClose3 = useCallback(async() => {
    onClose();
    setCloseFlag(true);
  }, [onClose]);
  
  return (
    <>
    {invalidTokenFlag ? (
      <>
        <Modal
          isOpen={isOpen}
          onClose={onClose2}
          motionPreset="slideInBottom"
          autoFocus={false}
          size="2xl"
          isCentered
          closeOnOverlayClick={false}
          allowPinchZoom
        >
          <ModalOverlay />
          <ModalContent pb={2}>
            <ModalHeader>{errTitle+'　失敗'}</ModalHeader>
            <ModalCloseButton />
            <ModalBody mx={6}>
              <Center>
                <Stack spacing={4}>
                  <Text color="tomato">最後のログインから時間が経過したため、セッションが切れています。</Text>
                  <Text>「再ログイン」ボタン選択後、ログイン画面から再ログインをお願いします。</Text>
                  <Text>{'　'}</Text>
                </Stack>
              </Center>
              <Center>
                <LogoutButton btnName="再ログイン" size="md" onClose={onClose} />
                <Text>{'　'}</Text>
              </Center>
            </ModalBody>
          </ModalContent>
        </Modal>
      </>
    
    ) : invalidVersionFlag ? (
      <>
        <Modal
          isOpen={isOpen}
          onClose={()=>{return;}}
          motionPreset="slideInBottom"
          autoFocus={false}
          size="2xl"
          isCentered
          closeOnOverlayClick={false}
        >
          <ModalOverlay />
          <ModalContent pb={2}>
            <ModalHeader>ツールアップデートのお知らせ</ModalHeader>
            <ModalCloseButton />
            <ModalBody mx={6}>
              <Center>
                <Stack spacing={4}>
                  <Text color="tomato">ツールをアップデートしています。</Text>
                  <Text>現在古い画面がキャッシュされておりますので、お手数ですが、ブラウザのリロードボタンから、ページ全体をリロードお願いいたします。</Text>
                  <Text></Text>
                  <Text>{'　'}</Text>
                </Stack>
              </Center>
            </ModalBody>
          </ModalContent>
        </Modal>
      </>
        
    ) : errMes.indexOf("システムエラー：") >= 0 || errTitle === 'ログイン処理' ? (
      <>
        <Modal
          isOpen={isOpen}
          onClose={onClose2}
          motionPreset="slideInBottom"
          autoFocus={false}
          size="2xl"
          isCentered
          closeOnOverlayClick={false}
        >
          <ModalOverlay />
          <ModalContent pb={2}>
            <ModalHeader>{errTitle+'　失敗'}</ModalHeader>
            <ModalCloseButton />
            <ModalBody mx={6}>
              <Center>
                <Stack spacing={4}>
                  <Text align="center" fontSize="xl" color="red">{errMes}</Text>
                  <Text>{'　'}</Text>
                </Stack>
              </Center>
              <Center>
                <LogoutButton btnName="ログアウト" size="md" onClose={onClose2} />
                <Text>{'　'}</Text>
              </Center>
            </ModalBody>
          </ModalContent>
        </Modal>
      </>
    
    ) : (
      <CompleteDialog
        title={errTitle+'　エラー　'+(errStatus && errStatus)}
        onExec={onClose3}
        execStr='閉じる'
        size="3xl"
      >
        <Box>
          <Text align="center" fontSize="xl" color="red">{`${errTitle}に失敗しました。`}</Text>
          <Text>{'　'}</Text>
          <Text align="center" fontSize="xl" color="red">{`${errMes}`}</Text>
        </Box>
      </CompleteDialog>
    )}
    </>
    
  );
};
